//const url = `https://vpic.nhtsa.dot.gov/api/vehicles/getmodelsformakeyear/make/honda/modelyear/2024?format=json`;
import { Helmet } from "react-helmet";
import { useState } from "react";
import http from "../http";
import { Select } from "antd";
import { Button, Row, Col } from "antd";

const OPTIONS = [
  "Nissan",
  "Toyota",
  "Honda",
  "Mitsubishi",
  "Ford",
  "Hyundai",
  "Kia",
  "Mercedes",
  "Lexus",
  "BMW",
  "Chevrolet",
  "Volkswagen",
  "Renault",
  "Mazda",
  "Dodge",
  "Audi",
  "Jeep",
  "Infiniti",
  "Land Rover",
  "Suzuki",
  "MG",
  "GMC",
  "Porsche",
  "Mini",
  "Tesla",
  "Peugeot",
  "Volvo",
  "Jaguar",
  "Lincoln",
  "Cadillac",
  "Subaru",
  "Jac",
  "Skoda",
  "Changan",
  "Daihatsu",
  "Maserati",
  "Chrysler",
  "Bentley",
  "Alfa Romeo",
  "Chery",
  "Geely",
  "Haval",
  "Rolls Royce",
  "Opel",
  "Fiat",
  "GAC",
  "Lamborghini",
  "Hummer",
  "Genesis",
  "Ferrari",
  "Aston Martin",
  "Seat",
  "Mercury",
  "Isuzu",
  "Bugatti",
  "Citroen",
  "Great Wall",
  "McLaren",
  "Baic",
  "Acura",
  "Lotus",
  "Mahindra",
  "Jetour",
  "Smart",
  "BYD",
  "Luxgen",
  "Ssangyong",
  "Saab",
  "CMC",
  "Victory",
  "Brilliance",
  "Maybach",
  "TATA",
  "ZNA",
  "Buick",
  "Bestune",
  "Maxus",
  "Pontiac",
  "Hino",
  "Hongqi",
  "Pagani",
  "Proton",
  "Sandstorm",
  "JMC",
  "Rover",
  "Fisker",
  "Dongfeng",
  "Dorcen",
  "Borgward",
  "Scion",
  "Lucid",
  "Rivian",
  "Jannarelly",
  "Ineos",
  "Koenigsegg",
  "Zotye",
  "Hero",
  "Senova",
  "Lada",
  "Leapmotor",
  "Cupra",
  "Morgan",
  "Skywell",
  "Exeed",
  "Noble",
  "CATERPILLAR",
  "Forthing",
  "Caterham",
  "OTOKAR",
  "Kaiyi",
  "PGO",
  "KOMATSU",
  "DFM",
  "YUTONG",
  "DAEWOO",
  "King Long",
  "KEYTON",
  "Foton",
  "Saturn",
  "Oullim",
  "ITALDESIGN",
  "Jinbei",
  "Huawei",
  "Gonow",
  "DFSK",
  "BUFORI",
  "Bajaj",
  "Soueast",
  "UAZ",
  "Weltmeister",
  "Changhe",
  "Abarth",
  "Speranza"
];

const CarInsurance = () => {
  const [selectedYear, setSelectedYear] = useState("2024");
  const [showMore, setShowMore] = useState(false);
  const [showMoreModels, setShowMoreModel] = useState(false);
  const [selectedItems, setSelectedItems] = useState("");
  const filteredOptions = OPTIONS.filter((o) => !selectedItems.includes(o));
  const [setCar, setSelectedCar] = useState("");
  const years = [
    2025, 2024, 2023, 2022, 2021, 2020, 2019, 2018, 2017, 2016, 2015, 2014,
    2013, 2012, 2011, 2010,
  ];
  const [step, setStep] = useState(1);
  const [models, setModels] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedSpec, setSelectedSpec] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    dob: "",
    mobile: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  const toggleShowMore = () => {
    setShowMore(!showMore);
  };

  const toggleShowMoreCar = () => {
    setShowMoreModel(!showMoreModels);
  }

  const handleYearClick = async (year) => {
    getVehicleInfo(year);
  };

  const handleClick = (event) => {
    if (step < 5) {
      setStep(step + 1);
    }
    const val = event.target.value;
    setSelectedItems(val);
  };

  const handleChange = (event) => {
    console.log("CLICKED");
  };

  const handleProceed = (event) => { 
    let url;
    if (selectedItems) {
      if (step < 5) {
        setStep(step + 1);
      }
    } else {
      
    }
  };

  const getVehicleInfo = async (year) => {
    var model;
    let url = `https://vpic.nhtsa.dot.gov/api/vehicles/getmodelsformakeyear/make/${selectedItems}/modelyear/${year}?format=json`;
    const response = await http.get(url);
    const modelsArray = response.data['Results'].map((item) => item.Model_Name);
    setModels(modelsArray);
    if (step < 5) {
      setStep(step + 1);
    }
    
  };

  const prevStep = () => {
    if (step > 1) {
      setStep(step - 1);
    }
  };

  const nextStep = () => {
    if (step < 5) {
      setStep(step + 1);
    }
  };

  const handleSpecSelect = (spec) => {
    setSelectedSpec(spec);
    if(spec){
      if (step < 5) {
        setStep(step + 1);
      }
    }
  };

  const setCarModel = (car) => {
    setSelectedCar(car);
    if(car){
      if (step < 5) {
        setStep(step + 1);
      }
    }
  }

  const renderStepContent = () => {
    switch (step) {
      case 1:
        return (
          <>
          <h2 style={{ marginBottom: 20, fontSize: 24 }}>
            Compare &amp;{" "}
            <span style={{ color: "#0066cc" }}>Save Up to 30%</span>
            <br /> on Car Insurance
          </h2>
            <Select
              style={{
                width: "100%",
                marginBottom: 20,
                borderRadius: 4,
                textAlign: "left",
              }}
              showSearch
              optionFilterProp="label"
              placeholder="Select an option below"
              options={filteredOptions.map((item) => ({
                value: item,
                label: item,
              }))}
              onChange={setSelectedItems}
            />
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: 16,
                marginBottom: 20,
                justifyContent: "center",
              }}
            >
              <button
                type="button"
                style={{
                  padding: "10px 20px",
                  width: "110.35px",
                  border: "1px solid #ccc",
                  borderRadius: 4,
                  cursor: "pointer",
                }}
                onClick={handleClick}
                value="Nissan"
                className="button"
              >
                Nissan
              </button>
              <button
                type="button"
                style={{
                  padding: "10px 20px",
                  width: "110.35px",
                  border: "1px solid #ccc",
                  borderRadius: 4,
                  cursor: "pointer",
                }}
                onClick={handleClick}
                value="Toyota"
                className="button"
              >
                Toyota
              </button>
              <button
                type="button"
                style={{
                  padding: "10px 20px",
                  width: "110.35px",
                  border: "1px solid #ccc",
                  borderRadius: 4,
                  cursor: "pointer",
                }}
                onClick={handleClick}
                value="Honda"
                className="button"
              >
                Honda
              </button>
              <button
                type="button"
                style={{
                  padding: "10px 20px",
                  width: "110.35px",
                  border: "1px solid #ccc",
                  borderRadius: 4,
                  cursor: "pointer",
                }}
                onClick={handleClick}
                value="Mitsubishi"
                className="button"
              >
                Mitsubishi
              </button>
              <button
                type="button"
                style={{
                  padding: "10px 20px",
                  width: "110.35px",
                  border: "1px solid #ccc",
                  borderRadius: 4,
                  cursor: "pointer",
                }}
                onClick={handleClick}
                value="Ford"
                className="button"
              >
                Ford
              </button>
              <button
                type="button"
                style={{
                  padding: "10px 20px",
                  width: "110.35px",
                  border: "1px solid #ccc",
                  borderRadius: 4,
                  cursor: "pointer",
                }}
                onClick={handleClick}
                value="Hyundai"
                className="button"
              >
                Hyundai
              </button>
              <button
                type="button"
                style={{
                  padding: "10px 20px",
                  width: "110.35px",
                  border: "1px solid #ccc",
                  borderRadius: 4,
                  cursor: "pointer",
                }}
                onClick={handleClick}
                value="TATA"
                className="button"
              >
                Tata
              </button>
              <button
                type="button"
                style={{
                  padding: "10px 20px",
                  width: "110.35px",
                  border: "1px solid #ccc",
                  borderRadius: 4,
                  cursor: "pointer",
                }}
                onClick={handleClick}
                value="Audi"
                className="button"
              >
                Audi
              </button>
            </div>
            <button
              type="button"
              style={{
                padding: 10,
                width: "100%",
                backgroundColor: "#ff3300",
                color: "white",
                border: "none",
                borderRadius: 4,
                cursor: "pointer",
                fontSize: 16,
              }}
              onClick={handleProceed}
            >
              Proceed
            </button>
          </>
        );
      case 2:
        return (
          <div>
            {/* Navigation Buttons */}
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <button style={navButtonStyle} onClick={prevStep}>
                &larr; Back
              </button>
              <button style={navButtonStyle} onClick={nextStep}>
                Next &rarr;
              </button>
            </div>

            <h2>Search your Car's model year</h2>
            <Select
                style={{
                  width: "100%",
                  marginBottom: 20,
                  borderRadius: 4,
                  textAlign: "left",
                }}
                showSearch
                optionFilterProp="label"
                placeholder="Select your car model below"
                options={years.map((item) => ({
                  value: item,
                  label: item,
                }))}
                value={selectedYear}
                onChange={handleYearClick}
              />
              
            <div>
              <p>Currently Selected</p>
              <div style={selectedYearStyle}>{selectedYear}</div>
            </div>

            {/* Year Selection Grid */}
            <div style={gridContainerStyle}>
              {years
                .slice(0, showMore ? years.length : 8)
                .map((year, index) => (
                  <div
                    key={index}
                    onClick={() => handleYearClick(year)}
                    style={{
                      ...yearButtonStyle,
                      borderColor: selectedYear === year ? "#007bff" : "#ccc",
                    }}
                  >
                    {year}
                  </div>
                ))}
            </div>

            {/* Show More / Show Less Button */}
            <button onClick={toggleShowMore} style={showMoreButtonStyle}>
              {showMore ? "Show less" : "Show more"}
            </button>
          </div>
        );
      case 3:
        return (
          <>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "20px",
              }}
            >
              <button style={navButtonStyle} onClick={prevStep}>
                &larr; Back
              </button>
              <button style={navButtonStyle} onClick={nextStep}>
                Next &rarr;
              </button>
            </div>

            {/* Title */}
            <h1 style={{ marginBottom: "10px", textAlign: "left" }}>
              Car Model
            </h1>

            {/* Search bar */}
            <Select
                style={{
                  width: "100%",
                  marginBottom: 20,
                  borderRadius: 4,
                  textAlign: "left",
                }}
                showSearch
                optionFilterProp="label"
                placeholder="Select your car model below"
                options={models.map((item) => ({
                  value: item,
                  label: item,
                }))}
                // value={selectedItems}
                onChange={setSelectedItems}
              />

            {/* Car model grid */}
            <Row gutter={[16, 16]}>
              {models.slice(0, showMoreModels ? 10 : 8).map((model, index) => (
                <Col xs={24} sm={12} md={12} key={index}>
                  <Button
                    style={{
                      width: "100%",
                      padding: "10px",
                      borderRadius: "8px",
                      borderColor: "#d9d9d9",
                    }}
                    onClick={() => setCarModel(model)}
                  >
                    
                    {model}
                  </Button>
                </Col>
              ))}
            </Row>

            <button onClick={toggleShowMoreCar} style={showMoreButtonStyle}>
              {showMoreModels ? "Show less" : "Show more"}
            </button>
          </>
        );
      case 4:
        return (
          <>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 30,
              }}
            >
              <button style={navButtonStyle} onClick={prevStep}>
                &larr; Back
              </button>
              <button style={navButtonStyle} onClick={nextStep}>
                Next &rarr;
              </button>
            </div>

            <h2 style={{ marginBottom: 20, textAlign: "left" }}>
              What is Your Vehicle's Specification ?
            </h2>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "20px",
              }}
            >
              <button
                onClick={() => handleSpecSelect("GCC Spec")}
                style={{
                  padding: "15px 30px",
                  border:
                    selectedSpec === "GCC Spec"
                      ? "2px solid #007BFF"
                      : "2px solid #ccc",
                  backgroundColor:
                    selectedSpec === "GCC Spec" ? "#F0F8FF" : "#fff",
                  color: "#007BFF",
                  borderRadius: "8px",
                  fontSize: "16px",
                  cursor: "pointer",
                  width: "235px",
                  transition: "background-color 0.3s",
                }}
              >
                GCC Spec
              </button>

              <button
                onClick={() => handleSpecSelect("Non-GCC Spec")}
                style={{
                  padding: "15px 30px",
                  border:
                    selectedSpec === "Non-GCC Spec"
                      ? "2px solid #007BFF"
                      : "2px solid #ccc",
                  backgroundColor:
                    selectedSpec === "Non-GCC Spec" ? "#F0F8FF" : "#fff",
                  color: "#007BFF",
                  borderRadius: "8px",
                  fontSize: "16px",
                  cursor: "pointer",
                  width: "235px",
                  transition: "background-color 0.3s",
                }}
              >
                Non-GCC Spec/Modified
              </button>
            </div>
          </>
        );
      case 5:
        return (
          <>
            <div
              style={{
                display: "flex",
                justifyContent: "left",
                marginBottom: "10px",
              }}
            >
              <button style={navButtonStyle} onClick={prevStep}>
                &larr; Back
              </button>
            </div>
            <h2 style={{ textAlign: "left" }}>Please Fill Your Details</h2>
            <form onSubmit={handleSubmit}>
              <div className="form-group" style={{ gap:"13px"}}>
                <input
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  style={{ width: "100%" }}
                />
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  style={{ width: "100%" }}
                />
              </div>

              <div className="form-group" style={{width:"100%", gap:"13px"}}>
                <input
                  type="text"
                  name="dob"
                  placeholder="Date of Birth (DD/MMM/YYYY)"
                  value={formData.dob}
                  onChange={handleChange}
                  required
                  style={{width:"56%"}}
                />
                <div className="mobile-group">
                  <span className="country-code">+971</span>
                  <input
                    type="tel"
                    name="mobile"
                    placeholder="Mobile Number"
                    value={formData.mobile}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <p className="disclaimer">
                By Clicking on "Proceed", I declare that I am a resident of UAE
                and holding a valid Visa and agree to the website{" "}
                <a href="#">Privacy Policy</a> and <a href="#">Terms of Use</a>.
              </p>

              <button type="submit" className="proceed-button">
                Proceed
              </button>
            </form>
          </>
        );
      default:
        return <div>Something Went Wrong!</div>;
    }
  };
  return (
    <>
      <Helmet>
        <title>Car Insaurance in cheap price</title>
      </Helmet>
      <main className="max-w-7xl mx-auto px-3 md:px-7 lg:px-2 flex flex-col-reverse lg:flex-row-reverse gap-6">
        {/* ==========   Sticky section  ======= */}
        <section>
          <div className="md:w-96 lg:w-64 bg-blue p-6 lg:p-4  rounded-lg sw-one sticky top-36 mx-auto">
            <h2 className="text-xl font-bold text-white text-center">
              Get Project Estimation
            </h2>
            <form className="mt-6 lg:mt-3">
              <input
                className="outline-none px-2 rounded py-1.5 lg:py-0.5 w-full bg-white"
                type="text"
                placeholder="Name"
              />
              <input
                className="outline-none px-2 rounded py-1.5 lg:py-0.5 w-full bg-white my-4"
                type="email"
                placeholder="Email"
              />
              <input
                className="outline-none px-2 rounded py-1.5 lg:py-0.5 w-full bg-white "
                type="number"
                placeholder="Phone number"
              />
              <select className=" outline-none px-2 rounded py-1.5 lg:py-0.5 w-full bg-white my-4">
                <option disabled="" selected="">
                  Select Budget
                </option>
                <option>USD 2000 - USD 5000</option>
                <option>USD 5000 - USD 10000</option>
                <option>USD 10000 - USD 20000</option>
                <option>USD 20000 - USD 40000</option>
                <option>USD 40000 - USD 60000</option>
                <option>USD 60000 - USD 90000</option>
                <option>USD 90000 - USD 130000</option>
                <option>USD 130000 - USD 200000</option>
                &gt;
              </select>
              <textarea
                className="outline-none px-2 rounded py-1.5 lg:py-0.5 w-full bg-white"
                placeholder="message"
                rows={3}
                defaultValue={""}
              />
              <button className="text-white bg-black px-6 mt-2 py-2 lg:py-1 rounded-md w-full font-medium">
                Submit
              </button>
            </form>
          </div>
        </section>
        {/* ====================================
                        Main section 
        ===================================== */}
        <section>
          {/* ====================================
                        Hero section
        ===================================== */}
          <section className="grid grid-cols-7 mt-8 md:mt-12 gap-6">
            <div className="col-span-7 lg:col-span-3">
              <img className="rounded-lg " src="image/car.jpg" alt="" />
              <p className="text-2xl mt-5 text-center font-bold">
                Accidents can happen, get Car Insurance!
              </p>
            </div>
            {/* compare section */}
            <div
              style={{
                backgroundColor: "white",
                padding: 30,
                borderRadius: 8,
                boxShadow: "rgba(0, 0, 0, 0.1) 0 0 10px 3px",
                textAlign: "center",
                width: "551px",
                height:'fit-content'
              }}
            >
              {renderStepContent()}
            </div>
          </section>
          {/* ====================================
                        Text section
        ===================================== */}
          <section className="mt-20 md:mt-32 ">
            <div className="text-lg font-medium text-gray-700 text-justify">
              <h2 className="text-2xl font-bold text-black">
                Why choose Insurance Cart for your car insurance needs in the
                Dubai?
              </h2>
              <p className="my-6">
                Looking for comprehensive car insurance in the UAE? Insurance
                Cart not only provides the best deals in terms of price,
                comparability, and convenience but also offers exclusive
                benefits to our customers across the Emirates, including Abu
                Dhabi, Sharjah, Al Ain, Ajman, Ras Al Khaimah, Fujairah, and Umm
                Al Quwain. Enjoy Zero Percent (0%) interest Equated Monthly
                Installments (EMI) with eligible credit cards for up to 12
                months, making insurance payments even more affordable.
                <br />
                <br />
                Our Comprehensive (First Party) Car Insurance covers a range of
                incidents, including accidental damages and theft, ensuring your
                peace of mind whether you're in bustling Abu Dhabi, vibrant
                Sharjah, picturesque Al Ain, bustling Ajman, scenic Ras Al
                Khaimah, tranquil Fujairah, or serene Umm Al Quwain. Whether
                your vehicle is on the road or parked, you're protected against
                damages from road accidents, housebreaking/robbery, motor engine
                damage due to accidental external means, and damages during
                transit by road, rail, inland waterway, lifts, elevator, or air.
                <br />
                <br />
                Getting your online insurance policy is a breeze with our
                user-friendly interface. Simply fill in your information on the
                premium calculator, click "get a price," and explore the
                available options. You can easily check the cost breakdown for
                each quotation. Follow the provided instructions to complete
                your online application, and rest assured that your digital
                insurance policy certificate will be delivered promptly within
                the next working hour.
              </p>
            </div>
            <div className="text-lg font-medium text-gray-700 text-justify">
              <h2 className="text-2xl font-bold text-black">
                What is Comprehensive or First-Party Motor Insurance?
              </h2>
              <p className="my-6">
                Comprehensive or First-Party Motor Insurance offers extensive
                coverage for your vehicle, safeguarding against accidental
                damages and theft, whether you're in the bustling streets of Abu
                Dhabi or enjoying the coastal roads of Fujairah. This policy
                covers damages arising from road accidents and losses due to
                housebreaking or robbery. It also extends protection to motor
                engine damage caused by accidental external means and any harm
                during transit by road, rail, inland waterway, lifts, elevator,
                or air.
              </p>
            </div>
            <div className="text-lg font-medium text-gray-700 text-justify">
              <h2 className="text-2xl font-bold text-black">
                Additional Coverages can be opted in for:
              </h2>
              <ul className="list-decimal ms-8 mt-6">
                <li>
                  <span className="font-bold">Flood &amp; Cyclone:</span>{" "}
                  Protection against damages caused by Typhoon, Hurricane,
                  Flood, Storm, Tempest, Cyclone, Hailstorm, Frost, or
                  inundation, etc.
                </li>
                <li>
                  <span className="font-bold">Earthquake:</span> Coverage for
                  damages resulting from earthquake effects, including fire and
                  shock damages, self-ignition, etc.
                </li>
                <li>
                  <span className="font-bold">Riot and Strike:</span> Safeguard
                  against damages caused by riots, strikes, malicious or violent
                  activities, etc.
                </li>
              </ul>
              <p className="my-6">
                Getting the right insurance is easy with Insurance Cart. Just
                fill in your information at the premium calculator online, click
                'get a price,' and explore the available options. You can view
                the breakdown of costs for each quotation before applying
                online. Follow the provided instructions on the subsequent pages
                to complete your application. For swift delivery, we provide a
                digital copy of the insurance policy certificate within the next
                working hour of placing an order through our website or mobile
                app, ensuring a hassle-free experience.
              </p>
            </div>
            <div className="text-lg font-medium text-gray-700 text-justify">
              <h2 className="text-2xl font-bold text-black">Claims</h2>
              <p className="my-6">
                In case of an unfortunate event, our claims process is designed
                to provide you with maximum convenience. Enjoy cashless claims
                settlement at our network motor workshops, ensuring a smooth
                repair service without any financial worries. If you need to
                raise a claim, our free claim assistance is at your service.{" "}
                <br />
                <br />
                At Insurance Cart, we prioritize your peace of mind. Choose us
                for car insurance, car insurance online, vehicle insurance,
                third-party car insurance, commercial vehicle insurance,
                third-party insurance, 3rd party car insurance, car insurance
                policy, renew car insurance, renew car insurance online, motor
                insurance policy, and automobile insurance policy. Our
                commitment is to deliver the best assurance for you and your car
                whenever you need it.
                <br />
                <br />
                Experience the ease of online insurance with Insurance Cart –
                your trusted partner for reliable and comprehensive car
                insurance solutions in the USA. Contact us for more information
                or any assistance you may need. We're here to make insurance
                simple and secure for you.
              </p>
            </div>
          </section>
        </section>
      </main>
    </>
  );
};

const navButtonStyle = {
  background: "none",
  border: "none",
  color: "#007bff",
  fontSize: "16px",
  cursor: "pointer",
};

const selectedYearStyle = {
  border: "1px solid #007bff",
  padding: "10px",
  borderRadius: "5px",
  width: "100px",
  textAlign: "center",
  color: "#007bff",
};

const gridContainerStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  gap: "10px",
  marginTop: "10px",
};

const yearButtonStyle = {
  padding: "10px",
  border: "1px solid #ccc",
  borderRadius: "5px",
  cursor: "pointer",
  textAlign: "center",
  transition: "border-color 0.3s",
};

const showMoreButtonStyle = {
  background: "none",
  border: "none",
  color: "#007bff",
  cursor: "pointer",
  marginTop: "20px",
};

export default CarInsurance;
